/** @format */

import { ArrowDropDownCircleOutlined } from '@mui/icons-material';
import {
  Box,
  MenuItem,
  Stack,
  SxProps,
  TextField,
  Theme,
  Typography,
} from '@mui/material';
import { toLowerCase } from '../../constants/commonFunction';
import { COMMON, PRIMARY } from '../../constants/style';
import VegaHeader from './VegaHeader';

export type VegaSelectSelectOptionType = {
  id: string;
  name: string;
  icon?: JSX.Element;
};

type Props = {
  options: string[] | VegaSelectSelectOptionType[];
  selected: string | VegaSelectSelectOptionType;
  onChange: (selected: string) => void;
  label?: string;
  className?: string;
  placeholder?: string;
  textFieldWidth?: number;
  disabled?: boolean;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  variant?: 'standard' | 'filled' | 'outlined';
  maxPopperHeight?: number;
  fontSize?: number;
  darkLabel?: boolean;
  onScroll?: any;
  focused?: boolean;
  isCurrency?: boolean;
  startAdornment?: any;
  error?: boolean;
  isFixedHeight?: boolean;
  errorHelperText?: string;
  headerText?: string;
  name?: any;
  errorText?: any;
};

const VegaSelect = ({
  options,
  selected,
  onChange,
  className,
  label,
  placeholder,
  textFieldWidth,
  disabled,
  size,
  sx,
  variant,
  maxPopperHeight,
  darkLabel,
  isCurrency,
  onScroll,
  focused = false,
  startAdornment,
  error = false,
  errorHelperText,
  isFixedHeight,
  headerText,
  fontSize,
  errorText,
  name,
}: Props) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {headerText?.length && <VegaHeader text={headerText} />}
      <TextField
        error={error}
        helperText={errorHelperText}
        select
        focused={focused}
        label={label}
        value={
          typeof selected === 'string' || typeof selected === 'number'
            ? selected
            : selected?.id
        }
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        defaultValue={label}
        fullWidth={!textFieldWidth}
        disabled={disabled}
        SelectProps={{
          IconComponent: ArrowDropDownCircleOutlined,
          MenuProps: {
            PaperProps: {
              sx: { maxHeight: maxPopperHeight || 300 },
              onScroll: onScroll ?? '',
            },
          },
          sx: {
            '& .MuiSvgIcon-root': {
              fontSize: '1.2rem',
              color: '#343434',
            },
          },
        }}
        // InputLabelProps={{
        //   style: {
        //     color: darkLabel ? PRIMARY.main : '#AFAFAF',
        //     textAlign: 'center',
        //     transform: focused ? '' : 'translateY(55%)',
        //     marginLeft: focused ? 0 : 12,
        //   },
        // }}
        InputProps={
          isFixedHeight
            ? {
                style: {
                  borderRadius: '9px',
                  height: '35px',
                },
                startAdornment: startAdornment,
              }
            : {
                style: {
                  borderRadius: '9px',
                  height: '40px',
                },
                startAdornment: startAdornment,
              }
        }
        size={size || 'small'}
        sx={{
          '& .MuiInputLabel-root': {
            ...(isFixedHeight
              ? { transform: 'translate(14px, 6px) scale(1)' }
              : { transform: 'translate(14px, 13px) scale(1)' }),
            // fontFamily: 'Aspekta-450 !important',
            // fontSize: 13,
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
          ...(textFieldWidth && { width: textFieldWidth }),
          '& .MuiFormLabel-root': {
            '&.Mui-focused': {
              color: `${PRIMARY.main} !important`,
            },
          },
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#AFAFAF',
              borderWidth: '1px',
              borderRadius: '9px',
            },
            ':hover fieldset': {
              borderColor: PRIMARY.main,
            },
          },
          ...sx,
        }}
        variant={variant}
      >
        {options.map((option, index) => {
          return (
            <MenuItem
              className={className ?? ''}
              key={index}
              value={typeof option === 'string' ? option : option.id}
              sx={{
                ...(textFieldWidth && { width: textFieldWidth }),
                whiteSpace: 'normal',
                textAlign: 'center',
              }}
            >
              <Stack
                className={className ?? ''}
                direction={'row'}
                gap={2}
                fontSize={fontSize}
                color={COMMON.gray}
                alignItems="center"
              >
                {typeof option !== 'string' && option.icon && option.icon}
                {isCurrency
                  ? typeof option === 'string'
                    ? option
                    : option.name
                  : typeof option === 'string'
                  ? toLowerCase(option)
                  : toLowerCase(option.name)}
              </Stack>
            </MenuItem>
          );
        })}
      </TextField>
      {errorText && (
        <Typography
          className="font-aspekta-500"
          color={'red'}
          fontSize={13}
          sx={{ position: 'absolute', right: 0 }}
        >
          {errorText[name]}
        </Typography>
      )}
    </Box>
  );
};

export default VegaSelect;
